import InputText from "../ReusableComponents/InputText";
import React, { useEffect, useState } from "react";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import TextArea from "../ReusableComponents/TextArea";
import { mainTable } from "../css/Common";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import Loader from "../ReusableComponents/Loader";
import MainPopup from "../popup-containers/MainPopup";
import { SpaceTypeHeader } from "../components/HeaderAttribute";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import SpacePopup from "../popup-containers/SpacePopup";
import toast from "react-hot-toast";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
const Space = () => {
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(true);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [popUpData, setPopUpData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [errors, setErrors] = useState({});
  const [rowIndex, setRowIndex] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [MstSpaceId, setMstSpaceId] = useState(0);
  const [bindSpace, setbindSpace] = useState([]);

  useEffect(() => {
    BindSpaceData();
  }, [mstClientId]);
  const BindSpaceData = async () => {
    try {
      setIsLoading(true); 
      const response = await BindPostAPI({ mstClientId }, "SpaceAPI/BindSpace");

      setbindSpace(response?.data?.Table || []);
      setIsLoading(false); 
    } catch (error) {
      console.error("Error fetching space data:", error);
      setbindSpace([]);
    }
  };

  var createdBy = sessionStorage.getItem("createdBy");
  var mstClientId = sessionStorage.getItem("MstClientId");

  const handleSubmit = async (rowIndex, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);

    const isValid = validateForm();

    if (flag === 1 || flag === 2) {
      if (!isValid) {
        setIsOpen(true);
        setIsLoading(false);
        setSubmitBtnDisabled(false);
        return;
      }

      setIsOpen(false);
      setIsLoading(true);

      const data = {
        mstSpaceId: MstSpaceId ? MstSpaceId : 0,
        mstClientId: mstClientId,
        space: formFields.space,
        description: formFields.description,
        createdBy: createdBy,
        flag: flag,
      };

      try {
        const response = await IUDAPI(data, "SpaceAPI/IUDSpace");
        console.log("IUDAPI response", response);

        if (flag === 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Space Data Inserted Successfully", {
              duration: 1000,
              position: "top-center",
            });
          } else {
            toast.error("Space Data Insert Failed", {
              duration: 1000,
              position: "top-center",
            });
          }
        } else if (flag === 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Space Data Modified Successfully", {
              duration: 1000,
              position: "top-center",
            });
          } else {
            toast.error("Space Data Modification Failed", {
              duration: 1000,
              position: "top-center",
            });
          }
        }

        setTimeout(cancel, 1000);
      } catch (error) {
        console.error("API error during insert/update:", error);
        toast.error("Something went wrong while saving space data", {
          duration: 1000,
          position: "top-center",
        });
        setIsLoading(false);
        setSubmitBtnDisabled(false);
      }
    } else {
      const data = {
        mstSpaceId: MstSpaceId,
        createdBy: createdBy,
        flag: flag,
      };

      try {
        const response = await IUDAPI(data, "SpaceAPI/IUDSpace");
        console.log("IUDAPI response", response);

        if (flag === 3) {
          if (response.data.Table[0].Result === "D") {
            toast.success("Space Data Deleted Successfully", {
              duration: 1000,
              position: "top-center",
            });
          } else {
            toast.error("Failed to Delete Space Data", {
              duration: 1000,
              position: "top-center",
            });
          }
        } else if (flag === 4) {
          if (response.data.Table[0].Result === "B") {
            toast.success("Space Data Inactivated Successfully", {
              duration: 1000,
              position: "top-center",
            });
          } else {
            toast.error("Space Data Inactivation Failed", {
              duration: 1000,
              position: "top-center",
            });
          }
        } else if (flag === 5) {
          if (response.data.Table[0].Result === "UB") {
            toast.success("Space Data Activated Successfully", {
              duration: 1000,
              position: "top-center",
            });
          } else {
            toast.error("Space Data Activation Failed", {
              duration: 1000,
              position: "top-center",
            });
          }
        }

        setTimeout(cancel, 1000);
      } catch (error) {
        console.error("API error during delete/activate/inactivate:", error);
        toast.error("Something went wrong. Please try again.", {
          duration: 1000,
          position: "top-center",
        });
        setIsLoading(false);
        setSubmitBtnDisabled(false);
      }
    }

    console.log("Submit Space Data:", formFields);
  };

  //   const validateForm = () => {
  //   const newErrors = {};

  //   if (!formFields.space.trim()) {
  //     newErrors.space = "Enter Space";
  //   }

  //   setErrors(newErrors);

  //   // Returns true if no errors
  //   return Object.keys(newErrors).length === 0;
  // };
  // check if duplicate exists with different MstSpaceId

  const validateForm = () => {
    const newErrors = {};
    const trimmedSpace = formFields.space.trim();

    if (!trimmedSpace) {
      newErrors.space = "Enter Space";
    } else if (
      bindSpace.some(
        (item) =>
          item.Space?.toLowerCase() === trimmedSpace.toLowerCase() &&
          item.MstSpaceId !== MstSpaceId
      )
    ) {
      newErrors.space = "This space already exists";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const cancel = () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setSubmitBtnDisabled(false);
    setIsLoading(false);
    BindSpaceData();
    setFormFields({
      space: "",
    });
    setFormFieldsError({
      spaceError: "",
    });
    setErrors({});
  };

  const [formFieldsError, setFormFieldsError] = useState({
    spaceError: "",
    descriptionError: "",
  });
  const [formFields, setFormFields] = useState({
    space: "",
    description: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));

    if (value.trim() !== "") {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };
  const handleSpace = (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setpopUpOpen(true);
    setPopUpData(bindSpace[rowIndex]);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);

      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);

      setUnBlockDetails(true);
    }

    const rowData = bindSpace[rowIndex];
    setMstSpaceId(bindSpace[rowIndex].MstSpaceId);

    setPopUpData(rowData);
  };

  const handleEdit = (rowIndex) => {
    setRowIndex(rowIndex);
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setFormFields({
      ...formFields,

      space: bindSpace[rowIndex].Space,
      description: bindSpace[rowIndex].Description,
    });
    setMstSpaceId(bindSpace[rowIndex].MstSpaceId);
  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(false);
    setAddScreenTitle(true);
    setErrors({});
  };

  //   const handleBlur = () => {
  //   setErrors((prevErrors) => ({
  //     ...prevErrors,
  //     space: formFields.space.trim() === "" ? "Enter Space" : "",
  //   }));
  //   bindSpace
  // };
  const handleBlur = () => {
    const trimmedSpace = formFields.space.trim();

    // // check if already exists in bindSpace (case-insensitive)
    // const isDuplicate = bindSpace.some(
    //   (item) => item.Space?.toLowerCase() === trimmedSpace.toLowerCase()
    // );

    // check if duplicate exists with different MstSpaceId
    const isDuplicate = bindSpace.some(
      (item) =>
        item.Space?.toLowerCase() === trimmedSpace.toLowerCase() &&
        item.MstSpaceId !== MstSpaceId
    );

    setErrors((prevErrors) => ({
      ...prevErrors,
      space:
        trimmedSpace === ""
          ? "Enter Space"
          : isDuplicate
          ? "This space already exists"
          : "",
    }));
  };

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Space"
          header={SpaceTypeHeader}
          records={bindSpace}
          handleEdit={handleEdit}
          handleAction={handleSpace}
          showAdd={showAdd}
          blockView={false}
        />
      )}
      {visibleAdd && (
        <>
          <div className="w-full">
            <div className="flex flex-col w-full">
              <div className={mainTable.clientMasterMainAdd}>
                <AddScreenTitle
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  title="Space"
                />
              </div>
            </div>

            <div className="mx-auto md:w-[500px] w-full">
              <div className="relative w-full h-full max-w-xl md:h-auto">
                <div className="relative bg-white rounded-lg shadow">
                  <div className="px-6 py-6 lg:px-8">
                    <form className="space-y-6" action="#">
                      <InputText
                        inputType="text"
                        title="Space"
                        name="space"
                        classStar="text-red-500"
                        placeholder="Enter Space"
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        content={formFields.space}
                        disabled={false}
                        // errorMessage={formFieldsError.spaceError}
                        isRequired={true}
                        errorMessage={errors.space}
                      />

                      <TextArea
                        title="Description"
                        rows={7}
                        name="description"
                        content={formFields.description}
                        resize={false}
                        placeholder="Enter Description"
                        controlFunc={(e) =>
                          setFormFields((prev) => ({
                            ...prev,
                            description: e.target.value,
                          }))
                        }
                        controlFuncBlur={() => {}}
                        disabled={false}
                        // tabIndex="0"
                        // errorMessage={formFieldsError.descriptionError}
                        errorMessage={errors.description}
                      />

                      <div className="flex justify-center mt-6">
                        <Buttons
                          addScreenTitle={addScreenTitle}
                          updateScreenTitle={updateScreenTitle}
                          disabledBtn={false}
                          viewSaveButton={false}
                          handleSubmit={handleSubmit}
                          cancel={cancel}
                          onClick={() =>
                            handleSubmit(0, addScreenTitle ? 1 : 2)
                          }
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup //Main Pop up
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(false)}
      >
        <div>
          <PopUpScreenTitle //Popup screen Title
            title="Space"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <SpacePopup data={popUpData} />
        </div>

        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default Space;
